import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/settly.webp';
import screenshot_target from '../../../images/letterfunnel/mariekevaniperen.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Marieke van Iperen"
      firstname="Marieke"
      companyname="Settly"
      competition="Localyze en Jobbatical"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/mariekevaniperen.js